import React from "react";

import './_devices.scss'
import {Breadcrumb, BreadcrumbItem, Column, Grid, Tile} from "@carbon/react";
import {Link} from "react-router-dom";
import UsersDevicesTable from "../../../components/UsersDevicesTable";

const UserDevices = ({}) => {
  return (
    <Grid fullWidth className="working-hours-page">
      <Column lg={16} md={8} sm={4}>
        <Grid className="page-banner">
          <Column lg={16} md={4} sm={4}>
            <Breadcrumb noTrailingSlash aria-label="Page navigation">
              <BreadcrumbItem>
                <Link to='/'>Home</Link>
              </BreadcrumbItem>
              <BreadcrumbItem>
                <Link to='/users/list'>Operatori</Link>
              </BreadcrumbItem>
              <BreadcrumbItem>
                Dispositivi
              </BreadcrumbItem>
            </Breadcrumb>
          </Column>
          <Column lg={16} md={4} sm={4}>
            <h1 className="page-heading">
              Dispositivi
            </h1>
          </Column>
        </Grid>
        <Grid>
          <Column lg={16} md={8} sm={4} className="devices-page__r1">
            <Tile>
              <UsersDevicesTable/>
            </Tile>
          </Column>
        </Grid>
      </Column>
    </Grid>
  )
}

export default UserDevices